<template>
  <el-select
    v-model="model.deliveryType"
    filterable
    clearable
    :multiple="multiple"
    value-key="id"
    :loading="loading"
    @change="selectDeliveryType"
    :placeholder="$t('common.select.placeholder')"
    :loading-text="$t('loading')"
    :no-data-text="$t('sales_orders.noDeliveryTypesFound')"
    @clear="$emit('clear')">
    <el-option
      v-for="type in deliveryTypesByLanguage($i18n.locale)"
      :key="type.id"
      :label="type.name"
      :value="type">
    </el-option>
  </el-select>
</template>
<script>

import { mapActions, mapState, mapGetters } from 'vuex';
export default {
	name: 'SelectDeliveryType',
  props: {
		deliveryType : {
      type : Array
    },
    multiple : {
      type : Boolean,
      default : true
    }
	},
	data() {
		return {
      model : {
        deliveryType : null
      },
      loading : false
	   }
   },
  computed: {
    ...mapState('controlData',['deliveryTypes']),
    ...mapGetters('controlData',['deliveryTypesByLanguage'])
  },
  components : {
  },
  methods : {
    initDeliveryTypes(){
      this.loading = true;
      this.fetchDeliveryTypes()
        .then(() => {
          this.loading = false;
        })
    },
    selectDeliveryType(deliveryType){
      this.$emit('selected',deliveryType);
    },
    ...mapActions('controlData',['fetchDeliveryTypes'])
  },
  watch: {
    deliveryType : function(newVal, oldVal){
      this.model.deliveryType = newVal
    }
  },
  created(){
    this.initDeliveryTypes();
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/_variables';

</style>
